<div class="primary-container">
  @if (leftButton) {
    <div class="left-button">
      <button
        mat-button
        (click)="leftButton.click()"
        [disabled]="getDisabledState(leftButton.disabled) | async"
      >
        {{ leftButton.label | translate }}
      </button>
    </div>
  }
  @if (rightButton) {
    <div>
      <button
        mat-button
        (click)="rightButton.click()"
        [disabled]="getDisabledState(rightButton.disabled) | async"
      >
        {{ rightButton.label | translate }}
      </button>
    </div>
  }
</div>
